import { AntPopover, Icons } from '@agro-club/agroclub-shared'
import { useAnalyticsClickHandler } from 'analytics/hooks'
import { isRussia } from 'env'
import { Bid, BidStatus, BidTypes } from 'modules/domain/bid/types'
import { FC, useState } from 'react'
import { generatePath } from 'react-router'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'
import { AButton } from 'views/components/Analytics'
import { BidTeamTag, BidTypeTag } from 'views/components/Tags'
import BidRoutes from 'views/pages/Bid/routes'
import { BidCardTags, CardButtonWrapper, ItemCard as CardWrapper } from 'views/styled/ItemCardStyles'
import { BidCardInfo } from './BidCardInfo'
import { BidPopoverContent } from './BidPopoverContent'
import { BidSampleTag } from 'views/components/Tags/BidSampleTag'
import { ProfileType } from 'modules/domain/user/types'

type Props = {
  setActiveBid: (arg: Bid) => void
  activeCard: boolean
  bid: Bid
  refetch?: () => void
}

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  max-width: 250px;
`

export const BidCard: FC<Props> = ({ bid, setActiveBid, activeCard, refetch }) => {
  const showActions = isRussia && bid.status === BidStatus.published && bid.bid_type === BidTypes.sale
  const handleClick = useAnalyticsClickHandler('bid')
  const [popoverVisible, setPopoverVisible] = useState(false)

  const { bidId } = useParams()
  const isBroker = bid.owner.profile?.profile_type === ProfileType.broker

  const tags = (
    <>
      {isBroker ? <BidTypeTag bid={bid} /> : null}
      <BidTeamTag bid={bid} />
      <BidSampleTag bid={bid} />
    </>
  )

  const activeBid = bidId === String(bid.id)

  return (
    <CardWrapper
      onClick={handleClick(() => setActiveBid(bid))}
      id={activeBid ? bidId : ''}
      activeCard={activeCard}
      status={bid.status}
    >
      <BidCardTags>{tags}</BidCardTags>
      <CardButtonWrapper>
        {showActions && refetch ? (
          <AntPopover
            content={<BidPopoverContent setPopoverVisible={setPopoverVisible} bid={bid} refetch={refetch} />}
            placement="bottomRight"
            trigger="click"
            open={popoverVisible}
            onOpenChange={() => setPopoverVisible(!popoverVisible)}
          >
            <AButton
              id="bitActions"
              color="secondary"
              background="none"
              Icon={Icons.IconMoreHoriz}
              onClick={(e) => e.stopPropagation()}
            />
          </AntPopover>
        ) : (
          <AButton
            Icon={Icons.IconOpen}
            to={generatePath(bid.status === BidStatus.potential ? BidRoutes.PotentialBidDetail : BidRoutes.Details, {
              id: bid.id,
            })}
            id="goToBid"
            color="secondary"
            background="none"
            analyticsPayload={{ id: bid.id }}
          />
        )}
      </CardButtonWrapper>
      <InfoWrapper>
        <BidCardInfo bid={bid} />
      </InfoWrapper>
    </CardWrapper>
  )
}
